import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { FaStar } from "react-icons/fa6";
import { Autoplay } from "swiper/modules";

const CarbonProducts = () => {
  const [products, setProducts] = useState([]);
  const [active, setActive] = React.useState(2);

  useEffect(() => {
    const getProducts = async () => {
      const response = await fetch("https://codefling.com/db/?category=21", {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      console.log(json);
      setProducts(json);
    };

    getProducts();
  }, []);

  return (
    <>
      <div id="plugins" style={{ transform: "translateY(-70px)" }}></div>
      <section
        className="carbon-products-section"
        style={{
          background: `url('/img/carbon-products-bg.png') no-repeat center center / cover`,
        }}
      >
        <div className="container px-max-sm-0">
          <h5 className="section-title">
            ONLY ON <br className="d-sm-none" /> CARBON
          </h5>
          <Swiper
            loop={true}
            spaceBetween={20}
            breakpoints={{
              320: {
                slidesPerView: 1.7,
                spaceBetween: 20,
                centeredSlides: true,
              },
              500: {
                slidesPerView: 2.3,
                spaceBetween: 30,
              },
              576: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              768: {
                slidesPerView: 3.2,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 5,
                spaceBetween: 30,
                centeredSlides: false,
              },
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
          >
            {products?.map((product, index) => (
              <SwiperSlide key={index}>
                <a
                  href={product.url}
                  target="#"
                  className="carbon-product-item"
                  data-aos="fade-up"
                >
                  <div className="img">
                    <img src={product.primaryScreenshot} alt="" />
                  </div>
                  <div
                    className="content"
                    style={{
                      background: `url(${
                        active === index
                          ? process.env.PUBLIC_URL + "/img/product-bg-2.png"
                          : process.env.PUBLIC_URL + "/img/product-bg-1.png"
                      }) no-repeat center center / cover`,
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="name">{product.title}</h6>
                      <span className="price">
                        {product.isPaid ? "$" + product.prices["USD"] : "Free"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="author">{product.author}</span>
                      <div className="product-ratings">
                        {[...Array(5)].map((_, index) => {
                          return (
                            <FaStar
                              key={index}
                              className={
                                index < product.rating
                                  ? "product-rating-star active"
                                  : "product-rating-star"
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="d-flex justify-content-center pt-4 mt-4">
            <a
              href="https://codefling.com/carbon"
              target="_blank"
              rel="noreferrer"
              className="view-all w-100"
              style={{ maxWidth: "196px" }}
            >
              <span>View All</span>
              <img src={process.env.PUBLIC_URL + "/img/all.png"} alt="" />
            </a>
          </div>
        </div>
      </section>

      <div className="d-flex justify-content-center">
        <img
          src={process.env.PUBLIC_URL + "/img/line.png"}
          alt=""
          className="mw-100"
        />
      </div>
    </>
  );
};

export default CarbonProducts;
